// eslint-disable-next-line import/prefer-default-export
export const EDIT_USER_PROFILE_SOURCES = {
  SCHEDULING: 'SCHEDULING',
  UNKNOWN: 'UNKNOWN',
  SETTINGS: 'SETTINGS',
  BILLING: 'BILLING',
};
// eslint-disable-next-line import/prefer-default-export
export const EDIT_CLIENT_PROFILE_SOURCES = {
  SCHEDULING: 'SCHEDULING',
  UNKNOWN: 'UNKNOWN',
  CLIENTS: 'CLIENTS',
  BILLING: 'BILLING',
};

/** How a client program became Behavior Tracking. */
export const BEHAVIOR_TRACKING_PROGRAM_SOURCES = {
  CREATED: 'created',
  TYPE_CHANGED: 'type_changed',
  COPIED_FROM_LIBRARY: 'copied_from_library',
  DUPLICATED: 'duplicated',
};

/** Where behavior data was recorded — the comparison the Behavior Tracking pilot measures. */
export const BEHAVIOR_DATA_CONTEXTS = {
  INDEPENDENT: 'independent',
  WITHIN_SKILL_ACQUISITION: 'within_skill_acquisition',
};

export const NOTIFICATION_ENTRY_POINTS = {
  TOAST: 'toast',
  NOTIFICATION_CENTER: 'notification_center',
  PUSH: 'push',
  UNKNOWN: 'unknown',
};

export const CANCELLED_APPOINTMENT_DESTINATIONS = {
  MY_SCHEDULE: 'my_schedule',
  SCHEDULING: 'scheduling',
};
